<template>
    <div id="mg">
        <!-- Loader -->
        <b-row no-gutters class="vh-100 loader-screen">
            <b-col align-self="center" class="text-white text-center">
                <b-img :src="logo" alt="logo-moregiros" width="128"/>
                <h1 class="mt-3">MORE<span class="font-weight-light">GIROS</span></h1>
                <p class="text-mute text-uppercase small">Giros Internacionales</p>
                <div class="laoderhorizontal">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </b-col>
        </b-row>
        <!-- Loader ends -->

        <transition name="fade" mode="out-in">
            <router-view @loader="hideLoader"></router-view>
        </transition>

        <chat-widget v-if="showChatWidget"></chat-widget>
        <admin-chat-widget v-if="showAdminWidget"></admin-chat-widget>
        <guest-chat-widget v-if="showGuestWidget"></guest-chat-widget>
    </div>
</template>

<script>
import ChatWidget from "./ChatWidget";
import AdminChatWidget from "./AdminChatWidget";
import GuestChatWidget from "./GuestChatWidget";

export default {
    name: "AppComponent",
    components: { ChatWidget, AdminChatWidget, GuestChatWidget },
    data: () => ({
        logo: '/img/logo.png'
    }),
    computed: {
        showChatWidget() {
            const user = this.$store.getters.user;
            return this.$store.getters.check && user && user.role !== 'Administrator';
        },
        showAdminWidget() {
            const user = this.$store.getters.user;
            return this.$store.getters.check && user && user.role === 'Administrator';
        },
        showGuestWidget() {
            return !this.$store.getters.check;
        }
    },
    methods: {
        hideLoader() {
            $('.loader-screen').fadeOut('slow');
        }
    }
}
</script>
